import { observable, action } from 'mobx';
import agent from '../services/web/agent';

import commonValidators from '../services/validations/commonValidators';
import userSharedFormsValidator from '../services/validations/userSharedFormsValidator';
import translationsStore from './translationsStore';

class MasterAccessControlStore {
    
    formErrors = [];

    @observable localURLValidationMessage;
    @observable nameValidationMessage;
    @observable savingMasterAC;
    @observable saveMasterACErrorMessage;


    @observable values = {
        name: '',
        localURL: '',
        active: undefined
    };

    @action reset() { 

        this.localURLValidationMessage = '';
        this.nameValidationMessage = '';
        this.saveMasterACErrorMessage = '';
        this.values.name = '';
        this.values.localURL = '';
        this.savingMasterAC = false;
        this.action = undefined;
    }


    validateLocalURL() {

        let validation = userSharedFormsValidator.validateGenericRequiredField(this.values.localURL);

        if (validation.errorCount < 1) {
            
            validation = commonValidators.validateUrl(this.values.localURL);
            this.localURLValidationMessage = validation.errors.first('url');
        }
        else {
            
            this.localURLValidationMessage = validation.errors.first('field');
        }

        this.formErrors.push(validation.errorCount);
    }

    validateName() {
  
        const validation = commonValidators.validateGenericRequiredField(this.values.name);

        this.nameValidationMessage = validation.errors.first('field');

        this.formErrors.push(validation.errorCount);
        
    }

    @action validateMasterACForm() { 

        this.formErrors = [];
        this.validateLocalURL();
        this.validateName();

        if (this.formErrors.filter((valid) => valid > 0).length > 0) {
            return false;   
        }

        return true;
    }


    @action async getMasterAccessControl() {

        try {
            const masterAC = await agent.MasterAccessControl.getMasterAccessControl();

            this.values.name = masterAC.name;
            this.values.localURL = masterAC.localUrl;
            this.values.active = masterAC.isActive;
            
        } catch (err){
            if(err.status !== 404)
                throw err;
        }

    }

    @action async SaveMasterAC() {
        this.savingMasterAC = true;
        this.saveMasterACErrorMessage = '';

        try {
            let localURL = this.values.localURL.trim();
            if(localURL[localURL.length-1] === '/'){
                localURL = localURL.substring(0, localURL.length-1);
            }

            const discoveryConfig = await agent.OpenIDConfiguration.getConfigurations(localURL);
            const issuer = discoveryConfig.body.issuer;
            const jwks = (await agent.OpenIDConfiguration.getJWKS(discoveryConfig.body.jwks_uri)).body;
                   
            try{
                await agent.MasterAccessControl.updateMasterAccessControl(localURL, this.values.name.trim(), issuer, jwks, this.values.active, discoveryConfig.body);
                await this.getMasterAccessControl();
            } catch (err){
                this.saveMasterACErrorMessage =  err.response && err.response.body && err.response.body.Message ? err.response.body.Message : err.message;
            }          
            
        } catch (err) {
            this.saveMasterACErrorMessage = translationsStore.translate('MASTER_ACCESS_CONTROL_CONNECTION_ERROR');
        } finally {
            this.savingMasterAC = false;
        }
    
    }

    @action setActive(active) {
        this.values.active = active;
    }

    @action setLocalURL(localURL) {
        this.values.localURL = localURL;
    }

    @action setName(name) {
        this.values.name = name;
    }
    @action setSaveMasterACErrorMessage(errorMessage) {
        this.saveMasterACErrorMessage = errorMessage;
    }

    @action emptyAllFieldValidationMessages() { 

        this.localURLValidationMessage = '';
        this.nameValidationMessage = '';
    }

    isExistSaveErrorMessage = () => this.saveMasterACErrorMessage !== '';
    
}

export default new MasterAccessControlStore();
